import { BaseEntity } from ".";
import { StaticStorageClient } from "../service/staticstorageclient";

const dataClient = new StaticStorageClient();
export class ConstellationEntity extends BaseEntity {
  constructor(id: number, props: any) {
    super(id, props);
    this._dataTypeName = "Constellation";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const id = this._id;
    const props = this.props;

    var entity = await super.toJson();

    // Properties
    if (entity.properties) {
      // - Data Type
      entity.properties["data_type"] = {
        type: Excel.CellValueType.string,
        basicValue: "Constellation",
      };
      // - Id
      entity.text = "Constellation";
      // - Name
      if (props.name.en) {
        entity.text = props.name.en;
        entity.properties["name"] = props.name.en;
      }
      if (props.factionID) {
        entity.properties["faction_id"] = entity.properties["factionID"];
        delete entity.properties["factionID"];
      }
      if (props.regionID) {
        entity.properties["region_id"] = entity.properties["regionID"];
        delete entity.properties["regionID"];
      }
      if (id) {
        const list = await dataClient.get_solarsystem_in_constellation(id);
        if (list) {
          let system_array: Excel.CellValue[][] = [];
          for (const y of list) {
            if (typeof y.solarSystemID === "number") {
              system_array.push([
                {
                  type: Excel.CellValueType.formattedNumber,
                  basicValue: parseInt(y.solarSystemID),
                  numberFormat: "#00",
                },
              ]);
            }
          }
          if (system_array.length) {
            entity.properties["systems_in_constellation"] = {
              type: Excel.CellValueType.array,
              elements: system_array,
            };
          }
        }
      }
    }
    // Layouts
    entity.layouts = {
      card: {
        //title: { property: "name" },
      },
      compact: {
        icon: "Atom",
      },
    };

    return entity;
  }
}
